/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import {
  CopyRightText,
  FooterAbout,
  FooterFlex,
  FooterMain,
  FooterNavigations,
  FooterSocialWrap,
  
} from "../../styles/footer";
import {
  RiDiscordLine,
  RiInstagramLine,
  RiLinkedinBoxLine,
  RiTwitterXLine,
} from "react-icons/ri";

interface PropsArgs {
  scrollToElement?: any;
  scrollToAbout?: any;
}

const Footer = ({ scrollToElement, scrollToAbout }: PropsArgs) => {
  const date = new Date();
  let year = date.getFullYear();


  return (
    <FooterMain>
      <div className="flex container">
        <FooterFlex>
          <FooterAbout>
            <div className="img_div">
              <img  loading ="lazy" src={"/images/sixthwhiteicon.png"} alt="sixth" />
            </div>
          </FooterAbout>
        </FooterFlex>

        <FooterFlex>
          <FooterNavigations>
            <div className="social-flex">
              <div className="footer-flex">
                <a href="/" target="_blank" rel="noreferrer">
                  {" "}
                  Home
                </a>

                <a href="/pricing" target="_blank" rel="noreferrer">
                  {" "}
                  pricing
                </a>

                <a
                  href="https://blog.trysixth.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  Blog
                </a>
                <a
                  href="https://docs.trysixth.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  Documentation
                </a>
                <a
                  href="/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                <a
                  href="/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms of Service
                </a>
                <a
                  href="/refund"
                  target="_blank"
                  rel="noreferrer"
                >
                  Refund Policy
                </a>
              </div>
            </div>
          </FooterNavigations>
        </FooterFlex>
        
        <FooterFlex>
          <FooterNavigations>
            <div className="footer-flex">
              <a       href="mailto:ope@trysixth.com?subject=Contact%20Us&body=Hello%20Sixth%20Team">
                {" "}
                ope@trysixth.com
              </a>
              <div className="social-flex">
                <a
                  href="https://twitter.com/sixth_hq"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <RiTwitterXLine size={28} />
                </a>

                <a
                  href="https://www.linkedin.com/mwlite/company/trysixth"
                  target="_blank"
                  rel="noreferrer"
                >
                  <RiLinkedinBoxLine size={28} />
                </a>

                <a
                  href="https://discord.gg/CyF9NrsaGg"
                  target="_blank"
                  rel="noreferrer"
                >
                  <RiDiscordLine size={28} />
                </a>

                <a
                  href="https://www.instagram.com/trysixth/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <RiInstagramLine size={28} />
                </a>
              </div>
              <CopyRightText>
                © {year}, SixHq Inc. | All Rights Reserved
              </CopyRightText>
            </div>
          </FooterNavigations>
        </FooterFlex>
      </div>
      <FooterSocialWrap>
        <div>
          <h2>
            <span>SIXTH</span>
          </h2>
        </div>
      </FooterSocialWrap>
    </FooterMain>
  );
};

export default Footer;
